import { Api } from "./api"

const PATH = 'order' 
const ENDPOINTS = {
    Liste:'liste',
    Store:'store',
    Show:'show',
    Update:'update',
    Delete:'delete',
    UpdateStatus:'update-status',
    Comment:'relance'
}

const getCommandes = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Liste}`, signal)
}

const getCommandeDetails = (id,signal) => {
    return Api.get(`${PATH}/${id}/${ENDPOINTS.Show}`, signal)
}

const storeCommande = (payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`,payload, signal)
}

const updateCommande = (id,payload,signal) => {
    return Api.update(`${PATH}/${id}/${ENDPOINTS.Update}`,payload, signal)
}

const deleteCommande = (id,signal) => {
    return Api.erase(`${PATH}/${id}/${ENDPOINTS.Delete}`, signal)
}
const updateStatus = (id,payload,signal) => {
    return Api.post(`${PATH}/${id}/${ENDPOINTS.UpdateStatus}`,payload, signal)
}

const comment = (id,signal) => {
    return Api.post(`${PATH}/${id}/${ENDPOINTS.Comment}`, signal)
}

export const CommandeApi={
    getCommandes,
    getCommandeDetails,
    storeCommande,
    updateCommande,
    deleteCommande,
    updateStatus,
    comment
    
}